
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/giftSubscription",
      function () {
        return require("private-next-pages/giftSubscription.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/giftSubscription"])
      });
    }
  